/**
 * Created by Justin Bernert on 14/12/2015.
 */

import { JoineryNode } from "../JoineryNode";
import { Utils } from "../../../utils/Utils";
import { PlanManager } from "../../../../../cocosPlan";
import { FrenchDoor, SceneConstants } from "@rhinov/savane-js";

declare var cc: any; 

export class FrenchDoorNode extends JoineryNode {

    //@private
    protected _nbDoors: number = 1;
    //@private
    protected _handleSide: number = SceneConstants.HandleSide.handle_left;
    //@private
    protected _openingSymetry: number = SceneConstants.Symetry.default;

    constructor(jDoor: FrenchDoor) {
        super(jDoor);
        this.computeModel(jDoor);
    }

    computeModel(joinery: FrenchDoor) {
        if (joinery !== undefined) {
            this._nbDoors = joinery.nbDoors;
            this._length = joinery.length;
            if (joinery.wall != null)
                this._thickness = joinery.wall.thickness;
            else
                this._thickness = this._length / 10;
            this._handleSide = joinery.handleSide;
            this._orientation = joinery.orientation;
            this._openingSymetry = joinery.openingSymetry;
            this._wallInstallTye = joinery.wallInstallType;
        }
        var idealSize = (this._length / 10 / this._nbDoors) * PlanManager.getInstance().getZoomScale();
        var foundSize = Utils.getClosestNumberInArray(idealSize, JoineryNode.ImageSizeExtentions);

        if (foundSize === 0) {
            foundSize = JoineryNode.ImageSizeExtentions[0];
        }
        for (var i = 0; i < this._nbDoors; ++i) {
            var sprite = new cc.Sprite();
            var spriteName = 'plan/frenchDoor' + foundSize + '.png';
            sprite.initWithSpriteFrameName(spriteName);
            sprite.setAnchorPoint(new cc.p((i + 1) - (this._nbDoors * 0.5), 1));
            if (this.transparentDraw) {
                sprite.setOpacity(64);
            }
            sprite.setPositionY(this.getY(10));
            sprite.setScaleX(this._length / (sprite.width * 10 * this._nbDoors));
            sprite.setScaleY(this._length / (sprite.width * 10 * this._nbDoors));
            sprite.setName('door-' + i);
            if (this._openingSymetry === SceneConstants.Symetry.default && i % 2 === 0) {
                sprite.setFlippedX(true);
            }
            if (this._nbDoors < 2) {
                if (this._handleSide !== SceneConstants.HandleSide.handle_left && !this._orientation
                    || this._handleSide === SceneConstants.HandleSide.handle_left && this._orientation) {
                    sprite.setFlippedX(false);
                }
                if (this._handleSide !== SceneConstants.HandleSide.handle_left && this._orientation
                    || this._handleSide === SceneConstants.HandleSide.handle_left && !this._orientation) {
                    sprite.setFlippedX(true);
                }
            }
            this.addChild(sprite, 8);
        }
    }

    getY(h: number): number {
        switch (this._wallInstallTye) {
            case 1:
                return -(this._thickness * 0.1) * 0.5;
            case 0:
                return (-h * 0.5);
            case -1:
                return ((this._thickness * 0.1) * 0.5 - 10);
        }
        return 0;
    }

    drawOverlap(_joinery: FrenchDoor, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }
        this.clear();
        if (this._thickness > 0) {
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};
            if (isValid != undefined) {
                color = this.getOverLapColor(isValid);
            } else {
                color = this.getOverLapColor(true);
            }
            var borderSize = 1;
            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }
            var white = new cc.color(255, 255, 255, alpha);
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), white, borderSize, white);

            // Default door thickness
            h = (100 * 0.1);

            y = this.getY(h) as number;

            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);

            var val2 = 0.066;
            var val1 = 0.015;

            if (this._handleSide === SceneConstants.HandleSide.handle_left && this._nbDoors === 1) {
                val2 = 0.015;
                val1 = 0.066;
            } else if (this._nbDoors !== 1) {
                val1 = 0.032;
                val2 = 0.032;
            }
            if (!this._orientation) {
                var tmp = val1;
                val1 = val2;
                val2 = tmp;
            }
            if (this._nbDoors === 2) {
                this.drawRect(new cc.p(x + w * 0.5 - w * 0.010, y - 0.5),
                    new cc.p(x + w * 0.5 + w * 0.01, y + h + 0.5),
                    new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            }
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * val1, y + h + 0.5),
                new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * val2, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5),
                new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
        }
    }
    updateModel(joinery: FrenchDoor, isValid: boolean) {
        this.removeAllChildren();
        this.computeModel(joinery);
        super.updateModel(joinery, isValid)
        this.drawOverlap(joinery, isValid);
    }
}
